import { FC } from 'react';
import { SvgContainer, SocialMedia, renderSVG } from './';
import {
  Facebook,
  Instagram,
  LinkedIn,
  TikTok,
  Twitter,
  YouTube,
  WhatsApp,
  EVInsider,
} from 'icons/index';

export interface SocialSubscribingProps {
  socialMedias: SocialMedia[];
}

//
// Component for linking to social media accounts
const SocialSubscribing: FC<SocialSubscribingProps> = ({ socialMedias }) => {
  //map the social media svg to the incoming social media array
  const socialMediasMap = {
    facebook: Facebook,
    twitter: Twitter,
    linkedin: LinkedIn,
    instagram: Instagram,
    youtube: YouTube,
    tiktok: TikTok,
    whatsapp: WhatsApp,
    insider: EVInsider,
  };
  return (
    <SvgContainer data-testid="social-media-links">
      {socialMedias.map((socialMedia) => {
        if (socialMedia == null) return null;
        if (!socialMediasMap[socialMedia.platform]) {
          return null;
        }
        const Component = socialMediasMap[socialMedia.platform];
        //take component name and convert it to a string
        const ComponentName = Component.name;
        return (
          <a
            data-testid={`${socialMedia.platform}-link`}
            href={socialMedia.url}
            target="_blank"
            rel="noreferrer"
            key={socialMedia.platform}
          >
            {renderSVG(Component, '16px')}
            <span className="visually-hidden">Link to {ComponentName} account</span>
          </a>
        );
      })}
    </SvgContainer>
  );
};

export default SocialSubscribing;
